<template>
  <v-app id="inspire" class="fontLao">
    <div>
            <v-toolbar flat color="white">
        <v-toolbar-title>ລາຍງານລາຍຮັບ-ຈ່າຍ</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="ຊອກຫາ" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar flat color="white">   
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

        <v-flex v-if="filldate" xs3 sm3 md3>
        <v-text-field  v-model="startdate" hide type="date" label="Start Date"></v-text-field>
        </v-flex>
       <v-spacer v-if="filldate"></v-spacer>
        <v-flex v-if="filldate" xs3 sm3 md3>
          <v-text-field v-model="enddate" type="date" label="End Date"></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <!-- <v-spacer></v-spacer> -->
        <!-- <v-select
          style=" margin-top: 18px; "
          :items="categories"
          item-value="id"
          item-text="name"
          v-model="categorie"
         
        ></v-select> -->
   <v-spacer></v-spacer>
           <v-btn
            color="primary"
            class="fontLao"
            @click="checkdisplay"
          >
            ຄົ້ນຫາ
          </v-btn>
        <v-dialog
          v-model="printdialog"
          width="A4"
        >
          <v-btn
            slot="activator"
            color="primary"
            class="fontLao"
            @click="_Print"
          >
            Print
          </v-btn>

          <v-card>
            <v-card-title
              class="headline primary white--text"
              primary-title
            >
              <v-spacer></v-spacer>
              <v-btn
                @click="Print_Invoice"
              >
                <v-icon>print</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text id="printdoc">
              <v-container grid-list-md v-for="(table, index) in dtprint" :key="index">
                <v-layout row wrap>
                  <v-flex xs4 text-xs-center>
                    <img 
                      width="180" 
                      src="data:image/png;base64,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" 
                      alt=""
                    >
                  </v-flex>
                  <v-flex xs8>
                    <h2>SANTISOUK SHOP<span style=" color: #e53935!important; ">3M</span></h2>
                    <p style=" margin-bottom: 0px; ">178 Hongkha Village, Chanthabouly District, Vientiane Capital LAO P.D.R</p>
                    <p>Tel: +85620 22234100, 020 91330973/Office: +85621 218478</p>
                    <h2 class="fontLao"> {{reportname}}   {{catname}}  {{_Date(startdate)}}  - {{_Date(enddate)}}   </h2>
                    <h4 v-if="cpage ='2'">
                      Stock page: {{index+1}} / {{dtprint.length}}
                    </h4>
                  </v-flex>
                </v-layout>
                
                <v-layout>
                  <v-flex xs12 :id="dtprint.length-1 == index ? 'f-table-l':'f-table-s'">
                    <table border='1' class="v-datatable v-table" style="text-align: center;">
                      <tr>
                        <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">No</th>
                        <!-- <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">BARCODE</th>  -->
                        <!-- <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Stock Number</th> -->
                        <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Product</th>
                        <!-- <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Categorie</th> -->
                        <!-- <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Unit</th> -->
                        <!-- <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Price</th> -->
                        <!-- <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Qty</th> -->
                        <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Stock In</th>
                        <!-- <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Back</th> -->
                        <!-- <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Balance Qty</th> -->
                        <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Stock Amount</th>
                        <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Stock Out/Sale Out</th>
                        <th style="font-size: 12px;line-height: initial;font-weight: 600;" class="cell">Stock Out Amount</th>
                      </tr>
                      <tr v-for="(item, ind) in table" :key="ind">
                        <!-- barcode stockno product categorie unit price qty shipped
                        back stockin stockinamount saleout saleoutamount date -->
                        <td style="font-size: 11px;height: 33px;">{{ind+1}}</td>
                        <!-- <td style="font-size: 11px;height: 33px;">{{item.barcode}}</td> -->
                        <!-- <td style="font-size: 11px;height: 33px;">{{item.stockno}}</td> -->
                        <td style="font-size: 11px;width: 40%;text-align: left;height: 33px;" class="fontLao">{{item.product}}</td>
                        <!-- <td style="font-size: 11px;height: 33px;"><span v-if="item.categorie">{{item.categorie}}</span></td> -->
                        <!-- <td style="font-size: 11px;height: 33px;"><span v-if="item.unit">{{item.unit}}</span></td> -->
                        <!-- <td style="font-size: 11px;height: 33px;"><span v-if="item.price">{{_P(item.price)}}</span></td> -->
                        <!-- <td style="font-size: 11px;height: 33px;">{{item.qty}}</td> -->
                        <td style="font-size: 11px;height: 33px;"><span >{{_D(item.shipped)}}</span></td>
                        <!-- <td style="font-size: 11px;height: 33px;"><span >{{item.back}}</span></td> -->
                        <!-- <td style="font-size: 11px;height: 33px;"><span >{{item.stockin}}</span></td> -->
                        <td style="font-size: 11px;height: 33px;"><span >{{_P(item.stockinamount)}}</span></td>
                        <td style="font-size: 11px;height: 33px;"><span >{{_D(item.saleout)}}</span></td>
                        <td style="font-size: 11px;height: 33px;"><span >{{_P(item.saleoutamount)}}</span></td>
                      </tr>
                      <tr v-if="dtprint.length-1 == index">
                        <th colspan="2" style="font-size: 12px;line-height: initial;font-weight: 600;">TOTAL: </th>
                        <!-- <td colspan="1" style="font-size: 12px;line-height: initial;font-weight: 600;"></td> -->
                        <td colspan="1" style="font-size: 12px;line-height: initial;font-weight: 600;">{{_D(sumshipped)}}</td>
                        <!-- <td colspan="1" style="font-size: 12px;line-height: initial;font-weight: 600;">{{sumback}}</td> -->
                        <!-- <td colspan="1" style="font-size: 12px;line-height: initial;font-weight: 600;">{{sumbalance}}</td> -->
                        <td colspan="1" style="font-size: 12px;line-height: initial;font-weight: 600;">{{_P(sumstockinamount)}}฿</td>
                        <td colspan="1" style="font-size: 12px;line-height: initial;font-weight: 600;">{{_D(sumsaleout)}}</td>
                        <td colspan="1" style="font-size: 12px;line-height: initial;font-weight: 600;">{{_P(sumsaleoutamount)}}฿</td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
                <v-layout v-if="dtprint.length-1 == index">
                  <v-flex style=" width: 400px; ">
                    <v-jumbotron height="115px" style="none">
                      <v-container fill-height style="padding-top: 2px;padding-bottom: 2px;">
                        <v-layout>
                          <v-flex>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-jumbotron>
                  </v-flex>
                  <!-- <v-flex style=" width: 285px; ">
                    <v-jumbotron height="115px" style="border: 2px solid;border-radius: 25px;">
                      <v-container fill-height style="padding-top: 0px;padding-bottom: 0px;">
                        <v-layout>
                          <v-flex>
                            <h4>ລາຍເຊັນ ແລະ ປະທັບຕາ:</h4>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-jumbotron>
                  </v-flex> -->
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table v-if="cpage == 1" :headers="headerspro" :items="mydatapro" :search="search" :rows-per-page-items=[500] class="elevation-1 fontLao">
        <template slot="items" slot-scope="props">
          <!-- <td>{{ props.item.no }}</td> -->
          <!-- <td>{{ props.item.barcode }}</td> -->
          <!-- <td>{{ props.item.stockno}}</td> -->
          <td>{{ props.item.product }}</td>
          <!-- <td>{{ props.item.categorie }}</td> -->
          <!-- <td>{{ props.item.unit }}</td> -->
          <!-- <td>{{ _P(props.item.price) }}</td> -->
          <!-- <td>{{ props.item.qty }}</td> -->
          <td>{{ _D(props.item.shipped) }}</td>
          <!-- <td> -->
            <!-- <span v-if="props.item.back > 0" class="red--text">{{ props.item.back }}</span> -->
            <!-- <span v-if="props.item.back == 0">{{ props.item.back }}</span> -->
          <!-- </td> -->
          <!-- <td>{{ props.item.stockin }}</td> -->
          <td>{{ _P(props.item.stockinamount) }} ฿</td>
          <td>{{ _D(props.item.saleout) }}</td>
          <td>{{ _P(props.item.saleoutamount) }} ฿</td>
          <!-- <td>{{ props.item.date }}</td> -->
        </template>
        <template slot="no-data">
          <v-progress-linear :indeterminate="loading"
            v-if="valuepre !== lengthpre"
          >
          </v-progress-linear>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import firebase from "firebase/app";
require("firebase/functions");
import axios from "axios";
import db from "@/firebase/init";
import moment from "moment";
import Printd from "printd";
export default {
  name: "ReportAll",
  data: () => ({
    valuepre: 0,
    lengthpre: 1,
    sumshipped: 0,
    sumback: 0,
    cpage:null,
    sumbalance: 0,
    sumstockinamount: 0,
    sumsaleout: 0,
    sumsaleoutamount: 0,
    dialog: false,
    dialogdatestock: false,
    filldate:false,
    search: "",
    categorie: "nan",
    datestock: new Date().toISOString().substr(0, 7),
    printdialog: false,
    dtprint: [],
    mydata: [],
    catname: "",
      startdate: null,
      enddate: null,
      loading:false,
    categories: [],
    headerspro: [
      // { text: "No", value: "no", align: "left" },
      // { text: "Barcode", value: "barcode", align: "left" },
      // { text: "Stock Number", value: "stockno", align: "left" },
      { text: "Product", value: "product", align: "left" },
      // { text: "Categorie", value: "categorie", align: "left" },
      // { text: "Unit", value: "unit", align: "left" },
      // { text: "Price", value: "price", align: "left" },
      // { text: "Qty", value: "qty", align: "left" },
      { text: "Stock In", value: "shipped", align: "left" },
      // { text: "Back", value: "back", align: "left" },
      // { text: "Balance Qty", value: "stockin", align: "left" },
      { text: "Stock Amount", value: "stockinamount", align: "left" },
      { text: "Stock Out/Sale Out", value: "sellqty", align: "left" },
      { text: "Sale Out Amount", value: "saleoutamount", align: "left" }
    ],
    mydatapro: []
  }),
  computed: {},
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogdatestock(val) {
      val || this.checkdisplay();
    },
    '$route.params.id': function (id) {
       this.initpagechange(id)
    }
  },
  created() {
  this.initpagechange(this.$route.params.id)
  },
  methods: {
    checkdisplay() {
          this.initializestockdate(this.categorie)
    },
    initpagechange(id){
        this.mydatapro=[]
        this.reportname=" ລາຍງານລາຍຮັບ-ລາຍຈ່າຍ "
        this.filldate=true
        this.cpage = 1
        this.initcategories()
    },
    initcategories() {
      let catdata = [];
      db.collection("categories")
        .where("stt", "==", 1)
        .get()
        .then(snapshot => {
          catdata.push({ id: "nan", name: "ເລືອກປະເພດ" });
          snapshot.forEach(doc => {
            let tmpdata = doc.data();
            tmpdata.id = doc.id;
            catdata.push(tmpdata);
          });
          this.categories = catdata;
        })
        .catch(err => {
          console.log("Error getting documents", err);
        });
    },
    _P(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    _D(value) {
      let val = (value / 1).toFixed(0).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    initializestockdate(cid,stock) {
      // console.log(cid)
      if (cid == null) return;
      let tdata = [];
      this.sumshipped = 0;
      this.sumback = 0;
      this.sumbalance = 0;
      this.sumstockinamount = 0;
      this.sumsaleout = 0;
      this.sumsaleoutamount = 0;
      db.collection("categories")
       .where("stt", "==", 1)
      //  .where("cid", "==", cid)
      //  .orderBy("no")
        .get()
        .then(snapshot => {
          snapshot.forEach(async doc => {
            let tmpdata = {
              id: null,
              barcode: null,
              stockno: null,
              product: null,
              categorie: null,
              unit: null,
              price: 0,
              qty: 0,
              shipped: 0,
              back: 0,
              stockin: 0,
              stockinamount: 0,
              saleout: 0,
              saleoutamount: 0,
              date: null
            };
            var docRef = db.collection("categories").doc(doc.id);
            let itemin = [];
              let start = new Date(this.startdate);
              let end = new Date(this.enddate);
              end.setHours(23)
              end.setMinutes(59)
              console.log(start)
              console.log(end)
            var dbstock = db.collection("stock").where("stt", "==", 1).where('date', '>', start).where('date', '<', end)
                await dbstock
                  .where("stock", "==", "in")
                  .where("categorieref", "==", docRef)
                  .get()
                  .then(_stock => {
                    _stock.forEach(doc => {
                      if (doc.exists) {
                        let tmpdatas = {
                          id: null,
                          price: null,
                          qty: null,
                          shipped: null,
                          back: null
                        };
                        tmpdatas.id = doc.id;
                        tmpdatas.price = doc.data().price;
                        tmpdatas.qty = doc.data().qty;
                        tmpdatas.shipped = doc.data().shipped;
                        tmpdatas.back = doc.data().back;
                        tmpdatas.amount = doc.data().amount;
                        const timestamp = doc.get("date");
                        const date = moment(timestamp.toDate()).format(
                          "DD/MM/YYYY"
                        );
                        tmpdatas.date = date;
                        itemin.push(tmpdatas);
                      }
                    });
                  });
              let itemout = [];
            await dbstock
              .where("stock", "==", "out")
              .where("categorieref", "==", docRef)
              .get()
              .then(_stock => {
                _stock.forEach( async doc => {
                  if (doc.exists) {
                    let tmpdatas = {
                      id: null,
                      price: null,
                      qty: null,
                      shipped: null,
                      back: null
                    };
                    tmpdatas.id = doc.id;
                    tmpdatas.price = doc.data().price;
                    tmpdatas.qty = doc.data().qty;
                    tmpdatas.amount = doc.data().amount;
                await    itemout.push(tmpdatas);
                  }
                });
              });
            tmpdata.no = doc.data().no;
            tmpdata.barcode = doc.data().bar;
            tmpdata.stockno = doc.data().stockno;
            tmpdata.product = doc.data().name;
            // if (doc.data().unid) {
            //   await db
            //     .collection("unit")
            //     .doc(doc.data().unid)
            //     .get()
            //     .then(doc => {
            //       if (doc.exists) {
            //         tmpdata.unit = doc.data().name;
            //       }
            //     });
            // }
            // if (doc.data().cid) {
            //   await db
            //     .collection("categories")
            //     .doc(doc.data().cid)
            //     .get()
            //     .then(doc => {
            //       if (doc.exists) {
            //         tmpdata.categorie = doc.data().name;
            //         this.catname = doc.data().name;
            //       }
            //     });
            // }

            // tmpdata.price = doc.data().price;
            tmpdata.qty = itemin.reduce((sum_, item) => sum_ + item.qty, 0);
            tmpdata.shipped = itemin.reduce(
              (sum_, item) => sum_ + item.shipped,
              0
            );
            this.sumshipped = tmpdata.shipped + this.sumshipped;
            tmpdata.back = itemin.reduce((sum_, item) => sum_ + item.back, 0);
            this.sumback = tmpdata.back + this.sumback;
            tmpdata.stockin =
              itemin.reduce((sum_, item) => sum_ + item.shipped, 0) -
              itemout.reduce((sum_, item) => sum_ + item.qty, 0);
            this.sumbalance = tmpdata.stockin + this.sumbalance;
            tmpdata.stockinamount = itemin.reduce(
              (sum_, item) => sum_ + item.amount,
              0
            );
            this.sumstockinamount = tmpdata.stockinamount + this.sumstockinamount;
            tmpdata.saleout = itemout.reduce(
              (sum_, item) => sum_ + item.qty,
              0
            );
            this.sumsaleout = tmpdata.saleout + this.sumsaleout;
            tmpdata.saleoutamount = itemout.reduce(
              (sum_, item) => sum_ + item.amount,
              0
            );
            this.sumsaleoutamount =tmpdata.saleoutamount + this.sumsaleoutamount;
            // console.log(itemin)
            //      await docRef.update({qtynow:tmpdata.stockin})
            if (itemin.length > 0) {
              let i = itemin[itemin.length - 1];
              tmpdata.date = i.date;
            }
            tdata.push(tmpdata);
          });
          this.mydatapro = tdata;
          //  console.log(this.mydatapro)
          //  this.sumshipped = tdata.reduce((sum_, item) => sum_ + item.shipped, 0)
          //  console.log(this.sumshipped)

          //
        });
      // console.log(this.sumshipped)
    },
    _Date(date){
     return moment(date).format("DD/MM/YYYY")
    },

    _Print() {
      this.mydata = this.mydatapro;
      //  let dt = this.mydata.sort(function(a, b){return a.itemno - b.itemno})
      let dt = this.mydata.sort(function(a, b) {
        return a.name - b.name;
      });
      let newdt = [];
      if (dt.length <= 16) {
        newdt.push(dt);
      }
      let pageinit = Math.floor(dt.length / 16) + 1;
      if (pageinit > 1) {
        for (let index = 0; index < pageinit; index++) {
          let last = (index + 1) * 16;
          if (last > dt.length) {
            last = dt.length;
          }
          newdt.push(dt.slice(index * 16, last));
        }
      }
      this.dtprint = newdt;
    },
    Print_Invoice() {
      const self = this;
      const app = self.$f7;
      self.d = new Printd();
      // Print dialog events (v0.0.9+)
      const { contentWindow } = self.d.getIFrame();
      contentWindow.addEventListener("beforeprint", function() {
        console.log("before print event!");
      });
      contentWindow.addEventListener("afterprint", () => {
        console.log("after print event!");
      });
      const cssText = `
        @media print {
          .table th.cell {
            background-color: blue !important;
          }
        }
        html {
          box-sizing: border-box;
          overflow-y: scroll; 
          -webkit-text-size-adjust: 100%; 
        }
        *,
        ::before,
        ::after {
          box-sizing: inherit;
        }
        ::before,
        ::after {
          text-decoration: inherit; 
          vertical-align: inherit;
        }
        * {
          background-repeat: no-repeat; 
          padding: 0; 
          margin: 0;
        }
        img {
          border-style: none;
        }
        html {
          font-size: 14px;
          overflow-x: hidden;
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
        }
        ::-ms-clear,
        ::-ms-reveal {
          display: none;
        }
        ul,
        ol {
          padding-left: 24px;
        }
        .title {
          font-size: 20px !important;
          font-weight: 500;
          line-height: 1 !important;
          letter-spacing: 0.02em !important;
          font-family: 'Roboto', sans-serif !important;
        }
        .subheading {
          font-size: 16px !important;
          font-weight: 400;
        }
        .body-2 {
          font-size: 14px !important;
          font-weight: 500;
        }
        .body-1 {
          font-size: 14px !important;
          font-weight: 400;
        }
        .caption {
          font-size: 12px !important;
          font-weight: 400;
        }
        p {
          margin-bottom: 16px;
        }
        .overflow-hidden {
          overflow: hidden;
        }
        .overflow-x-hidden {
          overflow-x: hidden;
        }
        .overflow-y-hidden {
          overflow-y: hidden;
        }
        .right {
          float: right !important;
        }
        .left {
          float: left !important;
        }
        .ma-auto {
          margin-top: auto !important;
          margin-right: auto !important;
          margin-bottom: auto !important;
          margin-left: auto !important;
        }
        .my-auto {
          margin-top: auto !important;
          margin-bottom: auto !important;
        }
        .mx-auto {
          margin-left: auto !important;
          margin-right: auto !important;
        }
        .mt-auto {
          margin-top: auto;
        }
        .mr-auto {
          margin-right: auto;
        }
        .mb-auto {
          margin-bottom: auto;
        }
        .ml-auto {
          margin-left: auto;
        }
        .ma-0 {
          margin: 0 0 !important;
        }
        .my-0 {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
        .mx-0 {
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
        .mt-0 {
          margin-top: 0 !important;
        }
        .mr-0 {
          margin-right: 0 !important;
        }
        .mb-0 {
          margin-bottom: 0 !important;
        }
        .ml-0 {
          margin-left: 0 !important;
        }
        .pa-0 {
          padding: 0 0 !important;
        }
        .py-0 {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }
        .px-0 {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }
        .pt-0 {
          padding-top: 0 !important;
        }
        .pr-0 {
          padding-right: 0 !important;
        }
        .pb-0 {
          padding-bottom: 0 !important;
        }
        .pl-0 {
          padding-left: 0 !important;
        }
        .ma-1 {
          margin: 4px 4px !important;
        }
        .my-1 {
          margin-top: 4px !important;
          margin-bottom: 4px !important;
        }
        .mx-1 {
          margin-left: 4px !important;
          margin-right: 4px !important;
        }
        .mt-1 {
          margin-top: 4px !important;
        }
        .mr-1 {
          margin-right: 4px !important;
        }
        .mb-1 {
          margin-bottom: 4px !important;
        }
        .ml-1 {
          margin-left: 4px !important;
        }
        .pa-1 {
          padding: 4px 4px !important;
        }
        .py-1 {
          padding-top: 4px !important;
          padding-bottom: 4px !important;
        }
        .px-1 {
          padding-left: 4px !important;
          padding-right: 4px !important;
        }
        .pt-1 {
          padding-top: 4px !important;
        }
        .pr-1 {
          padding-right: 4px !important;
        }
        .pb-1 {
          padding-bottom: 4px !important;
        }
        .pl-1 {
          padding-left: 4px !important;
        }
        .ma-2 {
          margin: 8px 8px !important;
        }
        .my-2 {
          margin-top: 8px !important;
          margin-bottom: 8px !important;
        }
        .mx-2 {
          margin-left: 8px !important;
          margin-right: 8px !important;
        }
        .mt-2 {
          margin-top: 8px !important;
        }
        .mr-2 {
          margin-right: 8px !important;
        }
        .mb-2 {
          margin-bottom: 8px !important;
        }
        .ml-2 {
          margin-left: 8px !important;
        }
        .pa-2 {
          padding: 8px 8px !important;
        }
        .py-2 {
          padding-top: 8px !important;
          padding-bottom: 8px !important;
        }
        .px-2 {
          padding-left: 8px !important;
          padding-right: 8px !important;
        }
        .pt-2 {
          padding-top: 8px !important;
        }
        .pr-2 {
          padding-right: 8px !important;
        }
        .pb-2 {
          padding-bottom: 8px !important;
        }
        .pl-2 {
          padding-left: 8px !important;
        }
        .ma-3 {
          margin: 16px 16px !important;
        }
        .my-3 {
          margin-top: 16px !important;
          margin-bottom: 16px !important;
        }
        .mx-3 {
          margin-left: 16px !important;
          margin-right: 16px !important;
        }
        .mt-3 {
          margin-top: 16px !important;
        }
        .mr-3 {
          margin-right: 16px !important;
        }
        .mb-3 {
          margin-bottom: 16px !important;
        }
        .ml-3 {
          margin-left: 16px !important;
        }
        .pa-3 {
          padding: 16px 16px !important;
        }
        .py-3 {
          padding-top: 16px !important;
          padding-bottom: 16px !important;
        }
        .px-3 {
          padding-left: 16px !important;
          padding-right: 16px !important;
        }
        .pt-3 {
          padding-top: 16px !important;
        }
        .pr-3 {
          padding-right: 16px !important;
        }
        .pb-3 {
          padding-bottom: 16px !important;
        }
        .pl-3 {
          padding-left: 16px !important;
        }
        .ma-4 {
          margin: 24px 24px !important;
        }
        .my-4 {
          margin-top: 24px !important;
          margin-bottom: 24px !important;
        }
        .mx-4 {
          margin-left: 24px !important;
          margin-right: 24px !important;
        }
        .mt-4 {
          margin-top: 24px !important;
        }
        .mr-4 {
          margin-right: 24px !important;
        }
        .mb-4 {
          margin-bottom: 24px !important;
        }
        .ml-4 {
          margin-left: 24px !important;
        }
        .pa-4 {
          padding: 24px 24px !important;
        }
        .py-4 {
          padding-top: 24px !important;
          padding-bottom: 24px !important;
        }
        .px-4 {
          padding-left: 24px !important;
          padding-right: 24px !important;
        }
        .pt-4 {
          padding-top: 24px !important;
        }
        .pr-4 {
          padding-right: 24px !important;
        }
        .pb-4 {
          padding-bottom: 24px !important;
        }
        .pl-4 {
          padding-left: 24px !important;
        }
        .ma-5 {
          margin: 48px 48px !important;
        }
        .my-5 {
          margin-top: 48px !important;
          margin-bottom: 48px !important;
        }
        .mx-5 {
          margin-left: 48px !important;
          margin-right: 48px !important;
        }
        .mt-5 {
          margin-top: 48px !important;
        }
        .mr-5 {
          margin-right: 48px !important;
        }
        .mb-5 {
          margin-bottom: 48px !important;
        }
        .ml-5 {
          margin-left: 48px !important;
        }
        .pa-5 {
          padding: 48px 48px !important;
        }
        .py-5 {
          padding-top: 48px !important;
          padding-bottom: 48px !important;
        }
        .px-5 {
          padding-left: 48px !important;
          padding-right: 48px !important;
        }
        .pt-5 {
          padding-top: 48px !important;
        }
        .pr-5 {
          padding-right: 48px !important;
        }
        .pb-5 {
          padding-bottom: 48px !important;
        }
        .pl-5 {
          padding-left: 48px !important;
        }
        .font-weight-thin {
          font-weight: 100 !important;
        }
        .font-weight-light {
          font-weight: 300 !important;
        }
        .font-weight-regular {
          font-weight: 400 !important;
        }
        .font-weight-medium {
          font-weight: 500 !important;
        }
        .font-weight-bold {
          font-weight: 700 !important;
        }
        .font-weight-black {
          font-weight: 900 !important;
        }
        .font-italic {
          font-style: italic !important;
        }
        .text-capitalize {
          text-transform: capitalize !important;
        }
        .text-lowercase {
          text-transform: lowercase !important;
        }
        .text-uppercase {
          text-transform: uppercase !important;
        }
        .text-no-wrap {
          white-space: nowrap !important;
        }
        .text-truncate {
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
        }
        .transition-fast-out-slow-in {
          transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }
        .transition-linear-out-slow-in {
          transition: 0.3s cubic-bezier(0, 0, 0.2, 1) !important;
        }
        .transition-fast-out-linear-in {
          transition: 0.3s cubic-bezier(0.4, 0, 1, 1) !important;
        }
        .transition-ease-in-out {
          transition: 0.3s cubic-bezier(0.4, 0, 0.6, 1) !important;
        }
        .transition-fast-in-fast-out {
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
        }
        .transition-swing {
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
        }
        @media screen {
          [hidden~="screen"] {
            display: inherit;
          }
          [hidden~="screen"]:not(:active):not(:focus):not(:target) {
            position: absolute !important;
            clip: rect(0 0 0 0) !important;
          }
        }
        @media only screen and (max-width: 599px) {
          .hidden-xs-only {
            display: none !important;
          }
        }
        @media only screen and (min-width: 600px) and (max-width: 959px) {
          .hidden-sm-only {
            display: none !important;
          }
        }
        @media only screen and (max-width: 959px) {
          .hidden-sm-and-down {
            display: none !important;
          }
        }
        @media only screen and (min-width: 600px) {
          .hidden-sm-and-up {
            display: none !important;
          }
        }
        @media only screen and (min-width: 960px) and (max-width: 1263px) {
          .hidden-md-only {
            display: none !important;
          }
        }
        @media only screen and (max-width: 1263px) {
          .hidden-md-and-down {
            display: none !important;
          }
        }
        @media only screen and (min-width: 960px) {
          .hidden-md-and-up {
            display: none !important;
          }
        }
        @media only screen and (min-width: 1264px) and (max-width: 1903px) {
          .hidden-lg-only {
            display: none !important;
          }
        }
        @media only screen and (max-width: 1903px) {
          .hidden-lg-and-down {
            display: none !important;
          }
        }
        @media only screen and (min-width: 1264px) {
          .hidden-lg-and-up {
            display: none !important;
          }
        }
        @media only screen and (min-width: 1904px) {
          .hidden-xl-only {
            display: none !important;
          }
        }
        @media all and (min-width: 0) {
          .text-xs-left {
            text-align: left !important;
          }
          .text-xs-center {
            text-align: center !important;
          }
          .text-xs-right {
            text-align: right !important;
          }
          .text-xs-justify {
            text-align: justify !important;
          }
        }
        @media all and (min-width: 600px) {
          .text-sm-left {
            text-align: left !important;
          }
          .text-sm-center {
            text-align: center !important;
          }
          .text-sm-right {
            text-align: right !important;
          }
          .text-sm-justify {
            text-align: justify !important;
          }
        }
        @media all and (min-width: 960px) {
          .text-md-left {
            text-align: left !important;
          }
          .text-md-center {
            text-align: center !important;
          }
          .text-md-right {
            text-align: right !important;
          }
          .text-md-justify {
            text-align: justify !important;
          }
        }
        @media all and (min-width: 1264px) {
          .text-lg-left {
            text-align: left !important;
          }
          .text-lg-center {
            text-align: center !important;
          }
          .text-lg-right {
            text-align: right !important;
          }
          .text-lg-justify {
            text-align: justify !important;
          }
        }
        @media all and (min-width: 1904px) {
          .text-xl-left {
            text-align: left !important;
          }
          .text-xl-center {
            text-align: center !important;
          }
          .text-xl-right {
            text-align: right !important;
          }
          .text-xl-justify {
            text-align: justify !important;
          }
        }

        .application {
          display: flex;
        }
        .application a {
          cursor: pointer;
        }
        .application--is-rtl {
          direction: rtl;
        }
        .application--wrap {
          flex: 1 1 auto;
          -webkit-backface-visibility: hidden;
                  backface-visibility: hidden;
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          max-width: 100%;
          position: relative;
        }
        .theme--light.application {
          background: #fafafa;
          color: rgba(0,0,0,0.87);
        }
        .theme--light.application .text--primary {
          color: rgba(0,0,0,0.87) !important;
        }
        .theme--light.application .text--secondary {
          color: rgba(0,0,0,0.54) !important;
        }
        .theme--light.application .text--disabled {
          color: rgba(0,0,0,0.38) !important;
        }
        .theme--dark.application {
          background: #303030;
          color: #fff;
        }
        .theme--dark.application .text--primary {
          color: #fff !important;
        }
        .theme--dark.application .text--secondary {
          color: rgba(255,255,255,0.7) !important;
        }
        .theme--dark.application .text--disabled {
          color: rgba(255,255,255,0.5) !important;
        }
        @-moz-document url-prefix() {
        }
        @media print {
          @-moz-document url-prefix() {
            .application {
              display: block;
            }
            .application--wrap {
              display: block;
            }
          }
        }

        .v-alert {
          border-radius: 0;
          border-width: 4px 0 0 0;
          border-style: solid;
          color: #fff;
          display: flex;
          margin: 4px auto;
          padding: 16px;
          position: relative;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        .v-alert .v-alert__icon.v-icon,
        .v-alert__dismissible .v-icon {
          align-self: center;
          color: rgba(0,0,0,0.3);
        }
        .v-alert--outline .v-icon {
          color: inherit !important;
        }
        .v-alert__icon {
          margin-right: 16px;
        }
        .v-alert__dismissible {
          align-self: flex-start;
          color: inherit;
          margin-left: 16px;
          margin-right: 0;
          text-decoration: none;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
          -webkit-user-select: none;
            -moz-user-select: none;
              -ms-user-select: none;
                  user-select: none;
        }
        .v-alert__dismissible:hover {
          opacity: 0.8;
        }
        .v-alert--no-icon .v-alert__icon {
          display: none;
        }
        .v-alert > div {
          align-self: center;
          flex: 1 1;
        }
        .v-alert.v-alert {
          border-color: rgba(0,0,0,0.12) !important;
        }
        .v-alert.v-alert--outline {
          border: 1px solid currentColor !important;
        }
        @media screen and (max-width: 600px) {
          .v-alert__icon {
            display: none;
          }
        }

        /* Themes */
        .theme--light.v-icon {
          color: rgba(0,0,0,0.54);
        }
        .theme--light.v-icon.v-icon--disabled {
          color: rgba(0,0,0,0.38) !important;
        }
        .theme--dark.v-icon {
          color: #fff;
        }
        .theme--dark.v-icon.v-icon--disabled {
          color: rgba(255,255,255,0.5) !important;
        }
        .v-icon {
          align-items: center;
          display: inline-flex;
          -webkit-font-feature-settings: 'liga';
                  font-feature-settings: 'liga';
          font-size: 24px;
          justify-content: center;
          line-height: 1;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
          vertical-align: text-bottom;
        }
        .v-icon.v-icon.v-icon--link {
          cursor: pointer;
        }
        .v-icon.v-icon--large {
          font-size: 2.5rem;
        }
        .v-icon.v-icon--medium {
          font-size: 2rem;
        }
        .v-icon.v-icon--x-large {
          font-size: 3rem;
        }
        .v-icon.v-icon--disabled {
          pointer-events: none;
        }

        .v-autocomplete.v-input > .v-input__control > .v-input__slot {
          cursor: text;
        }
        .v-autocomplete input {
          align-self: center;
        }
        .v-autocomplete--is-selecting-index input {
          opacity: 0;
        }
        .v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {
          margin-top: 24px;
        }
        .v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input {
          pointer-events: auto;
        }
        .v-autocomplete__content.v-menu__content {
          border-radius: 0;
        }
        .v-autocomplete__content.v-menu__content .v-card {
          border-radius: 0;
        }

        .theme--light.v-text-field .v-input__slot:before {
          border-color: rgba(0,0,0,0.42);
        }
        .theme--light.v-text-field:not(.v-input--has-state) .v-input__slot:hover:before {
          border-color: rgba(0,0,0,0.87);
        }
        .theme--light.v-text-field.v-input--is-disabled .v-input__slot:before {
          border-image: repeating-linear-gradient(to right, rgba(0,0,0,0.38) 0px, rgba(0,0,0,0.38) 2px, transparent 2px, transparent 4px) 1 repeat;
        }
        .theme--light.v-text-field__prefix,
        .theme--light.v-text-field__suffix {
          color: rgba(0,0,0,0.54);
        }
        .theme--light.v-text-field--solo .v-input__slot {
          border-radius: 2px;
          background: #fff;
        }
        .theme--light.v-text-field--solo-inverted.v-text-field--solo .v-input__slot {
          background: rgba(0,0,0,0.16);
        }
        .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused .v-input__slot {
          background: #424242;
        }
        .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused .v-input__slot .v-label,
        .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused .v-input__slot input {
          color: #fff;
        }
        .theme--light.v-text-field--box .v-input__slot {
          background: rgba(0,0,0,0.06);
        }
        .theme--light.v-text-field--box:not(.v-input--is-focused) .v-input__slot:hover {
          background: rgba(0,0,0,0.12);
        }
        .theme--light.v-text-field--outline .v-input__slot {
          border: 2px solid rgba(0,0,0,0.54);
        }
        .theme--light.v-text-field--outline:not(.v-input--is-focused) .v-input__slot:hover {
          border: 2px solid rgba(0,0,0,0.87);
        }
        .theme--dark.v-text-field .v-input__slot:before {
          border-color: rgba(255,255,255,0.7);
        }
        .theme--dark.v-text-field:not(.v-input--has-state) .v-input__slot:hover:before {
          border-color: #fff;
        }
        .theme--dark.v-text-field.v-input--is-disabled .v-input__slot:before {
          border-image: repeating-linear-gradient(to right, rgba(255,255,255,0.5) 0px, rgba(255,255,255,0.5) 2px, transparent 2px, transparent 4px) 1 repeat;
        }
        .theme--dark.v-text-field__prefix,
        .theme--dark.v-text-field__suffix {
          color: rgba(255,255,255,0.7);
        }
        .theme--dark.v-text-field--solo .v-input__slot {
          border-radius: 2px;
          background: #424242;
        }
        .theme--dark.v-text-field--solo-inverted.v-text-field--solo .v-input__slot {
          background: rgba(255,255,255,0.16);
        }
        .theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused .v-input__slot {
          background: #fff;
        }
        .theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused .v-input__slot .v-label,
        .theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused .v-input__slot input {
          color: rgba(0,0,0,0.87);
        }
        .theme--dark.v-text-field--box .v-input__slot {
          background: rgba(0,0,0,0.1);
        }
        .theme--dark.v-text-field--box:not(.v-input--is-focused) .v-input__slot:hover {
          background: rgba(0,0,0,0.2);
        }
        .theme--dark.v-text-field--outline .v-input__slot {
          border: 2px solid rgba(255,255,255,0.7);
        }
        .theme--dark.v-text-field--outline:not(.v-input--is-focused) .v-input__slot:hover {
          border: 2px solid #fff;
        }
        .application--is-rtl .v-text-field .v-label {
          -webkit-transform-origin: top right;
                  transform-origin: top right;
        }
        .application--is-rtl .v-text-field .v-counter {
          margin-left: 0;
          margin-right: 8px;
        }
        .application--is-rtl .v-text-field--enclosed .v-input__append-outer {
          margin-left: 0;
          margin-right: 16px;
        }
        .application--is-rtl .v-text-field--enclosed .v-input__prepend-outer {
          margin-left: 16px;
          margin-right: 0;
        }
        .application--is-rtl .v-text-field--reverse input {
          text-align: left;
        }
        .application--is-rtl .v-text-field--reverse .v-label {
          -webkit-transform-origin: top left;
                  transform-origin: top left;
        }
        .application--is-rtl .v-text-field__prefix {
          text-align: left;
          padding-right: 0;
          padding-left: 4px;
        }
        .application--is-rtl .v-text-field__suffix {
          padding-left: 0;
          padding-right: 4px;
        }
        .application--is-rtl .v-text-field--reverse .v-text-field__prefix {
          text-align: right;
          padding-left: 0;
          padding-right: 4px;
        }
        .application--is-rtl .v-text-field--reverse .v-text-field__suffix {
          padding-left: 0;
          padding-right: 4px;
        }
        .v-text-field {
          padding-top: 12px;
          margin-top: 4px;
        }
        .v-text-field input {
          flex: 1 1 auto;
          line-height: 20px;
          padding: 8px 0 8px;
          max-width: 100%;
          min-width: 0px;
          width: 100%;
        }
        .v-text-field .v-input__prepend-inner,
        .v-text-field .v-input__append-inner {
          align-self: flex-start;
          display: inline-flex;
          margin-top: 4px;
          line-height: 1;
          -webkit-user-select: none;
            -moz-user-select: none;
              -ms-user-select: none;
                  user-select: none;
        }
        .v-text-field .v-input__prepend-inner {
          margin-right: auto;
          padding-right: 4px;
        }
        .v-text-field .v-input__append-inner {
          margin-left: auto;
          padding-left: 4px;
        }
        .v-text-field .v-counter {
          margin-left: 8px;
          white-space: nowrap;
        }
        .v-text-field .v-label {
          max-width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          top: 6px;
          -webkit-transform-origin: top left;
                  transform-origin: top left;
          white-space: nowrap;
          pointer-events: none;
        }
        .v-text-field .v-label--active {
          max-width: 100%;
          -webkit-transform: translateY(-18px) scale(0.75);
                  transform: translateY(-18px) scale(0.75);
        }
        .v-text-field > .v-input__control > .v-input__slot {
          cursor: text;
          transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        .v-text-field > .v-input__control > .v-input__slot:before,
        .v-text-field > .v-input__control > .v-input__slot:after {
          bottom: -1px;
          content: '';
          left: 0;
          position: absolute;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
          width: 100%;
        }
        .v-text-field > .v-input__control > .v-input__slot:before {
          border-style: solid;
          border-width: thin 0 0 0;
        }
        .v-text-field > .v-input__control > .v-input__slot:after {
          border-color: currentColor;
          border-style: solid;
          border-width: thin 0 thin 0;
          -webkit-transform: scaleX(0);
                  transform: scaleX(0);
        }
        .v-text-field__details {
          display: flex;
          flex: 1 0 auto;
          max-width: 100%;
          overflow: hidden;
        }
        .v-text-field__prefix,
        .v-text-field__suffix {
          align-self: center;
          cursor: default;
        }
        .v-text-field__prefix {
          width: 16px;
          text-align: right;
          padding-right: 4px;
        }
        .v-text-field__suffix {
          padding-left: 4px;
          white-space: nowrap;
        }
        .v-text-field--reverse .v-text-field__prefix {
          text-align: left;
          padding-right: 0;
          padding-left: 4px;
        }
        .v-text-field--reverse .v-text-field__suffix {
          padding-left: 0;
          padding-right: 4px;
        }
        .v-text-field__slot {
          display: flex;
          flex: 1 1 auto;
          position: relative;
        }
        .v-text-field--box,
        .v-text-field--outline {
          position: relative;
        }
        .v-text-field--box .v-input__slot,
        .v-text-field--outline .v-input__slot {
          align-items: stretch;
        }
        .v-text-field--box input,
        .v-text-field--outline input {
          margin-top: 22px;
        }
        .v-text-field--box.v-text-field--single-line input,
        .v-text-field--outline.v-text-field--single-line input {
          margin-top: 12px;
        }
        .v-text-field--box .v-label,
        .v-text-field--outline .v-label {
          top: 18px;
        }
        .v-text-field--box .v-label--active,
        .v-text-field--outline .v-label--active {
          -webkit-transform: translateY(-6px) scale(0.75);
                  transform: translateY(-6px) scale(0.75);
        }
        .v-text-field--box .v-input__slot,
        .v-text-field--outline .v-input__slot {
          min-height: 56px;
        }
        .v-text-field--box .v-input__slot {
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }
        .v-text-field--box .v-input__slot:before {
          border-style: solid;
          border-width: thin 0 thin 0;
        }
        .v-text-field.v-text-field--enclosed {
          margin: 0;
          padding: 0;
        }
        .v-text-field.v-text-field--enclosed:not(.v-text-field--box) .v-progress-linear__background {
          display: none;
        }
        .v-text-field.v-text-field--enclosed .v-input__prepend-outer,
        .v-text-field.v-text-field--enclosed .v-input__prepend-inner,
        .v-text-field.v-text-field--enclosed .v-input__append-inner,
        .v-text-field.v-text-field--enclosed .v-input__append-outer {
          margin-top: 16px;
        }
        .v-text-field.v-text-field--enclosed .v-text-field__details,
        .v-text-field.v-text-field--enclosed .v-input__slot {
          padding: 0 12px;
        }
        .v-text-field.v-text-field--enclosed .v-text-field__details {
          margin-bottom: 8px;
        }
        .v-text-field.v-text-field--full-width.v-input {
          margin-bottom: 0;
          margin-top: 0;
        }
        .v-text-field.v-text-field--full-width .v-label {
          top: calc(50% - 12px);
        }
        .v-text-field.v-text-field--full-width .v-input__control {
          padding: 12px 0;
        }
        .v-text-field.v-text-field--full-width .v-input__prepend-outer,
        .v-text-field.v-text-field--full-width .v-input__append-outer {
          margin-top: 4px;
        }
        .v-text-field.v-text-field--full-width .v-input__append-inner {
          align-self: center;
          margin-top: 0;
        }
        .v-text-field--reverse input {
          text-align: right;
        }
        .v-text-field--reverse .v-label {
          -webkit-transform-origin: top right;
                  transform-origin: top right;
        }
        .v-text-field--reverse .v-input__slot,
        .v-text-field--reverse .v-text-field__slot {
          flex-direction: row-reverse;
        }
        .v-text-field--solo .v-input__slot:before,
        .v-text-field--outline .v-input__slot:before,
        .v-text-field--full-width .v-input__slot:before,
        .v-text-field--solo .v-input__slot:after,
        .v-text-field--outline .v-input__slot:after,
        .v-text-field--full-width .v-input__slot:after {
          display: none;
        }
        .v-text-field--outline {
          margin-bottom: 16px;
          transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        .v-text-field--outline .v-input__slot {
          background: transparent !important;
          border-radius: 4px;
        }
        .v-text-field--outline .v-input__prepend-outer,
        .v-text-field--outline .v-input__append-outer {
          margin-top: 18px;
        }
        .v-text-field--outline.v-input--is-focused .v-input__slot {
          border: 2px solid currentColor;
          transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        .v-text-field.v-text-field--solo .v-label {
          top: calc(50% - 12px);
        }
        .v-text-field.v-text-field--solo .v-input__control {
          min-height: 48px;
          padding: 0;
        }
        .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
          box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
        }
        .v-text-field.v-text-field--solo .v-text-field__slot {
          align-items: center;
        }
        .v-text-field.v-text-field--solo .v-input__append-inner,
        .v-text-field.v-text-field--solo .v-input__prepend-inner {
          align-self: center;
          margin-top: 0;
        }
        .v-text-field.v-text-field--solo .v-input__prepend-outer,
        .v-text-field.v-text-field--solo .v-input__append-outer {
          margin-top: 12px;
        }
        .v-text-field.v-input--is-focused .v-input__slot:after {
          -webkit-transform: scaleX(1);
                  transform: scaleX(1);
        }
        .v-text-field.v-input--has-state .v-input__slot:before {
          border-color: currentColor;
        }

        .theme--light.v-select .v-select__selections {
          color: rgba(0,0,0,0.87);
        }
        .theme--light.v-select.v-input--is-disabled .v-select__selections {
          color: rgba(0,0,0,0.38);
        }
        .theme--light.v-select .v-chip--disabled,
        .theme--light.v-select .v-select__selection--disabled {
          color: rgba(0,0,0,0.38);
        }
        .theme--light.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selections {
          color: #fff;
        }
        .theme--dark.v-select .v-select__selections {
          color: #fff;
        }
        .theme--dark.v-select.v-input--is-disabled .v-select__selections {
          color: rgba(255,255,255,0.5);
        }
        .theme--dark.v-select .v-chip--disabled,
        .theme--dark.v-select .v-select__selection--disabled {
          color: rgba(255,255,255,0.5);
        }
        .theme--dark.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selections {
          color: rgba(0,0,0,0.87);
        }
        .v-select {
          position: relative;
        }
        .v-select > .v-input__control > .v-input__slot {
          cursor: pointer;
        }
        .v-select .v-chip {
          flex: 0 1 auto;
        }
        .v-select .fade-transition-leave-active {
          position: absolute;
          left: 0;
        }
        .v-select.v-input--is-dirty ::-webkit-input-placeholder {
          color: transparent !important;
        }
        .v-select.v-input--is-dirty :-ms-input-placeholder {
          color: transparent !important;
        }
        .v-select.v-input--is-dirty ::-ms-input-placeholder {
          color: transparent !important;
        }
        .v-select.v-input--is-dirty ::placeholder {
          color: transparent !important;
        }
        .v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {
          padding-top: 24px;
        }
        .v-select.v-text-field input {
          flex: 1 1;
          margin-top: 0;
          min-width: 0;
          pointer-events: none;
          position: relative;
        }
        .v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
          -webkit-transform: rotate(180deg);
                  transform: rotate(180deg);
        }
        .v-select.v-select--chips input {
          margin: 0;
        }
        .v-select.v-select--chips .v-select__selections {
          min-height: 42px;
        }
        .v-select.v-select--chips.v-select--chips--small .v-select__selections {
          min-height: 32px;
        }
        .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box .v-select__selections,
        .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections {
          min-height: 68px;
        }
        .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box.v-select--chips--small .v-select__selections,
        .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-select--chips--small .v-select__selections {
          min-height: 56px;
        }
        .v-select.v-text-field--reverse .v-select__slot,
        .v-select.v-text-field--reverse .v-select__selections {
          flex-direction: row-reverse;
        }
        .v-select__selections {
          align-items: center;
          display: flex;
          flex: 1 1 auto;
          flex-wrap: wrap;
          line-height: 18px;
        }
        .v-select__selection {
          max-width: 90%;
        }
        .v-select__selection--comma {
          align-items: center;
          display: inline-flex;
          margin: 7px 4px 7px 0;
        }
        .v-select__slot {
          position: relative;
          align-items: center;
          display: flex;
          width: 100%;
        }
        .v-select:not(.v-text-field--single-line) .v-select__slot > input {
          align-self: flex-end;
        }
        .v-menu {
          display: block;
          position: relative;
          vertical-align: middle;
        }
        .v-menu--inline {
          display: inline-block;
        }
        .v-menu__activator {
          align-items: center;
          cursor: pointer;
          display: flex;
          position: relative;
        }
        .v-menu__activator * {
          cursor: pointer;
        }
        .v-menu__activator--disabled {
          pointer-events: none;
        }
        .v-menu__content {
          position: absolute;
          display: inline-block;
          border-radius: 2px;
          max-width: 80%;
          overflow-y: auto;
          overflow-x: hidden;
          contain: content;
          will-change: transform;
          box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 12px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
        }
        .v-menu__content--active {
          pointer-events: none;
        }
        .v-menu__content > .card {
          contain: content;
          -webkit-backface-visibility: hidden;
                  backface-visibility: hidden;
        }
        .v-menu > .v-menu__content {
          max-width: none;
        }
        .v-menu-transition-enter .v-list__tile {
          min-width: 0;
          pointer-events: none;
        }
        .v-menu-transition-enter-to .v-list__tile {
          pointer-events: auto;
          transition-delay: 0.1s;
        }
        .v-menu-transition-leave-active,
        .v-menu-transition-leave-to {
          pointer-events: none;
        }
        .v-menu-transition-enter,
        .v-menu-transition-leave-to {
          opacity: 0;
        }
        .v-menu-transition-enter-active,
        .v-menu-transition-leave-active {
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        }
        .v-menu-transition-enter.v-menu__content--auto .v-list__tile {
          opacity: 0;
          -webkit-transform: translateY(-15px);
                  transform: translateY(-15px);
        }
        .v-menu-transition-enter.v-menu__content--auto .v-list__tile--active {
          opacity: 1;
          -webkit-transform: none !important;
                  transform: none !important;
          pointer-events: auto;
        }
        .v-card {
          display: block;
          border-radius: 2px;
          min-width: 0;
          position: relative;
          text-decoration: none;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
          box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
        }
        .v-card--raised {
          box-shadow: 0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12);
        }
        .v-card--tile {
          border-radius: 0;
        }
        .v-card--flat {
          box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12);
        }
        .v-card--hover {
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
          transition-property: box-shadow;
        }
        .v-card--hover:hover {
          box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 12px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
        }
        .v-card__title {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          padding: 16px;
        }
        .v-card__title--primary {
          padding-top: 24px;
        }
        .v-card__text {
          padding: 16px;
          width: 100%;
        }
        .v-card__actions {
          align-items: center;
          display: flex;
          padding: 8px;
        }
        .v-list {
          list-style-type: none;
          padding: 8px 0 8px;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        .v-list .v-input .v-messages {
          display: none;
        }
        .v-list .v-input,
        .v-list .v-input__slot {
          margin: 0;
        }
        .v-list > div {
          transition: inherit;
        }
        .v-list__tile {
          align-items: center;
          color: inherit;
          display: flex;
          font-weight: 400;
          height: 48px;
          margin: 0;
          padding: 0 16px;
          position: relative;
          text-decoration: none;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        .v-list__tile--link {
          cursor: pointer;
          -webkit-user-select: none;
            -moz-user-select: none;
              -ms-user-select: none;
                  user-select: none;
        }
        .v-list__tile__content,
        .v-list__tile__action {
          height: 100%;
        }
        .v-list__tile__title,
        .v-list__tile__sub-title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
          width: 100%;
        }
        .v-list__tile__title {
          height: 24px;
          line-height: 24px;
          position: relative;
          text-align: left;
        }
        .v-list__tile__avatar {
          display: flex;
          justify-content: flex-start;
          min-width: 56px;
        }
        .v-list__tile__action {
          display: flex;
          justify-content: flex-start;
          min-width: 56px;
          align-items: center;
        }
        
        .v-list__tile__action--stack {
          align-items: flex-end;
          justify-content: space-between;
          padding-top: 8px;
          padding-bottom: 8px;
          white-space: nowrap;
          flex-direction: column;
        }
        .v-list__tile__content {
          text-align: left;
          flex: 1 1 auto;
          overflow: hidden;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
        }
        .v-list__tile__content ~ .v-list__tile__avatar {
          justify-content: flex-end;
        }
        .v-list__tile__content ~ .v-list__tile__action:not(.v-list__tile__action--stack) {
          justify-content: flex-end;
        }
        .v-list__tile--active .v-list__tile__action:first-of-type .v-icon {
          color: inherit;
        }
        .v-list__tile--avatar {
          height: 56px;
        }
        .v-list--dense {
          padding-top: 4px;
          padding-bottom: 4px;
        }
        .v-list--dense .v-list__group .v-subheader {
          height: 40px;
        }
        .v-list--dense .v-list__tile--avatar {
          height: 48px;
        }
        .v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
          height: 40px;
        }
        .v-list--disabled {
          pointer-events: none;
        }
        .v-list--two-line .v-list__tile {
          height: 72px;
        }
        .v-list--two-line.v-list--dense .v-list__tile {
          height: 60px;
        }
        .v-list--three-line .v-list__tile {
          height: 88px;
        }
        .v-list--three-line .v-list__tile__avatar {
          margin-top: -18px;
        }
        .v-list--three-line .v-list__tile__sub-title {
          white-space: initial;
          -webkit-line-clamp: 2;
          display: -webkit-box;
        }
        .v-list--three-line.v-list--dense .v-list__tile {
          height: 76px;
        }
        .v-list > .v-list__group:before {
          top: 0;
        }
        .v-list > .v-list__group:before .v-list__tile__avatar {
          margin-top: -14px;
        }
        .v-list__group {
          padding: 0;
          position: relative;
          transition: inherit;
        }
        .v-list__group:before,
        .v-list__group:after {
          content: '';
          height: 1px;
          left: 0;
          position: absolute;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
          width: 100%;
        }
        .v-list__group--active ~ .v-list__group:before {
          display: none;
        }
        .v-list__group__header {
          align-items: center;
          cursor: pointer;
          display: flex;
          list-style-type: none;
        }
        .v-list__group__header > div:not(.v-list__group__header__prepend-icon):not(.v-list__group__header__append-icon) {
          flex: 1 0 auto;
        }
        .v-list__group__header .v-list__group__header__append-icon,
        .v-list__group__header .v-list__group__header__prepend-icon {
          padding: 0 16px;
          -webkit-user-select: none;
            -moz-user-select: none;
              -ms-user-select: none;
                  user-select: none;
        }
        .v-list__group__header--sub-group {
          align-items: center;
          display: flex;
        }
        .v-list__group__header--sub-group div .v-list__tile {
          padding-left: 0;
        }
        .v-list__group__header--sub-group .v-list__group__header__prepend-icon {
          padding: 0 0 0 40px;
          margin-right: 8px;
        }
        .v-list__group__header .v-list__group__header__prepend-icon {
          display: flex;
          justify-content: flex-start;
          min-width: 56px;
        }
        .v-list__group__header--active .v-list__group__header__append-icon .v-icon {
          -webkit-transform: rotate(-180deg);
                  transform: rotate(-180deg);
        }
        .v-list__group__header--active .v-list__group__header__prepend-icon .v-icon {
          color: inherit;
        }
        .v-list__group__header--active.v-list__group__header--sub-group .v-list__group__header__prepend-icon .v-icon {
          -webkit-transform: rotate(-180deg);
                  transform: rotate(-180deg);
        }
        .v-list__group__items {
          position: relative;
          padding: 0;
          transition: inherit;
        }
        .v-list__group__items > div {
          display: block;
        }
        .v-list__group__items--no-action .v-list__tile {
          padding-left: 72px;
        }
        .v-list__group--disabled {
          pointer-events: none;
        }
        .v-list--subheader {
          padding-top: 0;
        }

        .v-avatar {
          align-items: center;
          border-radius: 50%;
          display: inline-flex;
          justify-content: center;
          position: relative;
          text-align: center;
          vertical-align: middle;
        }
        .v-avatar img,
        .v-avatar .v-icon,
        .v-avatar .v-image {
          border-radius: 50%;
          display: inline-flex;
          height: inherit;
          width: inherit;
        }
        .v-avatar--tile {
          border-radius: 0;
        }
        .v-avatar--tile img,
        .v-avatar--tile .v-icon,
        .v-avatar--tile .v-image {
          border-radius: 0;
        }

        /* Theme */
        .theme--light.v-counter {
          color: rgba(0,0,0,0.54);
        }
        .theme--dark.v-counter {
          color: rgba(255,255,255,0.7);
        }
        .v-counter {
          flex: 0 1 auto;
          min-height: 12px;
          line-height: 1;
        }

        .v-progress-linear {
          background: transparent;
          margin: 1rem 0;
          overflow: hidden;
          width: 100%;
          position: relative;
        }
        .v-progress-linear__bar {
          width: 100%;
          height: inherit;
          position: relative;
          transition: 0.2s;
          z-index: 1;
        }
        .v-progress-linear__bar__determinate {
          height: inherit;
          transition: 0.2s;
        }
        .v-progress-linear__bar__indeterminate .long,
        .v-progress-linear__bar__indeterminate .short {
          height: inherit;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          will-change: left, right;
          width: auto;
        }
        .v-progress-linear__bar__indeterminate--active .long {
          -webkit-animation: indeterminate;
                  animation: indeterminate;
          -webkit-animation-duration: 2.2s;
                  animation-duration: 2.2s;
          -webkit-animation-iteration-count: infinite;
                  animation-iteration-count: infinite;
        }
        .v-progress-linear__bar__indeterminate--active .short {
          -webkit-animation: indeterminate-short;
                  animation: indeterminate-short;
          -webkit-animation-duration: 2.2s;
                  animation-duration: 2.2s;
          -webkit-animation-iteration-count: infinite;
                  animation-iteration-count: infinite;
        }
        .v-progress-linear__background {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          transition: 0.3s ease-in;
        }
        .v-progress-linear--query .v-progress-linear__bar__indeterminate--active .long {
          -webkit-animation: query;
                  animation: query;
          -webkit-animation-duration: 2s;
                  animation-duration: 2s;
          -webkit-animation-iteration-count: infinite;
                  animation-iteration-count: infinite;
        }
        .v-progress-linear--query .v-progress-linear__bar__indeterminate--active .short {
          -webkit-animation: query-short;
                  animation: query-short;
          -webkit-animation-duration: 2s;
                  animation-duration: 2s;
          -webkit-animation-iteration-count: infinite;
                  animation-iteration-count: infinite;
        }
        @-webkit-keyframes indeterminate {
          0% {
            left: -90%;
            right: 100%;
          }
          60% {
            left: -90%;
            right: 100%;
          }
          100% {
            left: 100%;
            right: -35%;
          }
        }
        @keyframes indeterminate {
          0% {
            left: -90%;
            right: 100%;
          }
          60% {
            left: -90%;
            right: 100%;
          }
          100% {
            left: 100%;
            right: -35%;
          }
        }
        @-webkit-keyframes indeterminate-short {
          0% {
            left: -200%;
            right: 100%;
          }
          60% {
            left: 107%;
            right: -8%;
          }
          100% {
            left: 107%;
            right: -8%;
          }
        }
        @keyframes indeterminate-short {
          0% {
            left: -200%;
            right: 100%;
          }
          60% {
            left: 107%;
            right: -8%;
          }
          100% {
            left: 107%;
            right: -8%;
          }
        }
        @-webkit-keyframes query {
          0% {
            right: -90%;
            left: 100%;
          }
          60% {
            right: -90%;
            left: 100%;
          }
          100% {
            right: 100%;
            left: -35%;
          }
        }
        @keyframes query {
          0% {
            right: -90%;
            left: 100%;
          }
          60% {
            right: -90%;
            left: 100%;
          }
          100% {
            right: 100%;
            left: -35%;
          }
        }
        @-webkit-keyframes query-short {
          0% {
            right: -200%;
            left: 100%;
          }
          60% {
            right: 107%;
            left: -8%;
          }
          100% {
            right: 107%;
            left: -8%;
          }
        }
        @keyframes query-short {
          0% {
            right: -200%;
            left: 100%;
          }
          60% {
            right: 107%;
            left: -8%;
          }
          100% {
            right: 107%;
            left: -8%;
          }
        }

        .v-badge {
          display: inline-block;
          position: relative;
        }
        .v-badge__badge {
          color: #fff;
          display: flex;
          position: absolute;
          top: -12px;
          right: -22px;
          border-radius: 50%;
          height: 22px;
          width: 22px;
          justify-content: center;
          align-items: center;
          flex-direction: row;
          flex-wrap: wrap;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        .v-badge--overlap .v-badge__badge {
          top: -8px;
          right: -8px;
        }
        .v-badge--overlap.v-badge--left .v-badge__badge {
          left: -8px;
          right: initial;
        }
        .v-badge--overlap.v-badge--bottom .v-badge__badge {
          bottom: -8px;
          top: initial;
        }
        .v-badge--left .v-badge__badge {
          left: -22px;
        }
        .v-badge--bottom .v-badge__badge {
          bottom: -12px;
          top: initial;
        }
        .v-item-group.v-bottom-nav {
          bottom: 0;
          box-shadow: 0 3px 14px 2px rgba(0,0,0,0.12);
          display: flex;
          left: 0;
          justify-content: center;
          -webkit-transform: translate(0, 60px);
                  transform: translate(0, 60px);
          transition: all 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
          width: 100%;
        }
        .v-item-group.v-bottom-nav--absolute {
          position: absolute;
        }
        .v-item-group.v-bottom-nav--active {
          -webkit-transform: translate(0, 0);
                  transform: translate(0, 0);
        }
        .v-item-group.v-bottom-nav--fixed {
          position: fixed;
          z-index: 4;
        }
        
        .v-item-group {
          flex: 1 0 auto;
          position: relative;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        .v-item-group > * {
          cursor: pointer;
          flex: 1 1 auto;
        }

        .v-bottom-sheet.v-dialog {
          align-self: flex-end;
          border-radius: 0;
          flex: 1 0 100%;
          margin: 0;
          min-width: 100%;
          overflow: visible;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        }
        .v-bottom-sheet.v-dialog.v-bottom-sheet--inset {
          max-width: 70%;
          min-width: 0;
        }
        @media only screen and (max-width: 599px) {
          .v-bottom-sheet.v-dialog.v-bottom-sheet--inset {
            max-width: none;
          }
        }

        .v-dialog {
          box-shadow: 0px 12px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);
          border-radius: 2px;
          margin: 24px;
          overflow-y: auto;
          pointer-events: auto;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
          width: 100%;
          z-index: inherit;
        }
        .v-dialog__content {
          align-items: center;
          display: flex;
          height: 100%;
          justify-content: center;
          left: 0;
          pointer-events: none;
          position: fixed;
          top: 0;
          transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
          width: 100%;
          z-index: 6;
          outline: none;
        }
        .v-dialog:not(.v-dialog--fullscreen) {
          max-height: 90%;
        }
        .v-dialog__activator {
          cursor: pointer;
        }
        .v-dialog__activator * {
          cursor: pointer;
        }
        .v-dialog__activator--disabled {
          pointer-events: none;
        }
        .v-dialog__container {
          display: inline-block;
          vertical-align: middle;
        }
        .v-dialog--animated {
          -webkit-animation-duration: 0.15s;
                  animation-duration: 0.15s;
          -webkit-animation-name: animate-dialog;
                  animation-name: animate-dialog;
          -webkit-animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
                  animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
        }
        .v-dialog--fullscreen {
          border-radius: 0;
          margin: 0;
          height: 100%;
          position: fixed;
          overflow-y: auto;
          top: 0;
          left: 0;
        }
        .v-dialog--fullscreen > .v-card {
          min-height: 100%;
          min-width: 100%;
          margin: 0 !important;
          padding: 0 !important;
        }
        .v-dialog--scrollable {
          display: flex;
        }
        .v-dialog--scrollable > .v-card {
          display: flex;
          flex: 1 1 auto;
          flex-direction: column;
        }
        .v-dialog--scrollable > .v-card > .v-card__title,
        .v-dialog--scrollable > .v-card > .v-card__actions {
          flex: 1 0 auto;
        }
        .v-dialog--scrollable > .v-card > .v-card__text {
          overflow-y: auto;
          -webkit-backface-visibility: hidden;
                  backface-visibility: hidden;
        }
        @-webkit-keyframes animate-dialog {
          0% {
            -webkit-transform: scale(1);
                    transform: scale(1);
          }
          50% {
            -webkit-transform: scale(1.03);
                    transform: scale(1.03);
          }
          100% {
            -webkit-transform: scale(1);
                    transform: scale(1);
          }
        }
        @keyframes animate-dialog {
          0% {
            -webkit-transform: scale(1);
                    transform: scale(1);
          }
          50% {
            -webkit-transform: scale(1.03);
                    transform: scale(1.03);
          }
          100% {
            -webkit-transform: scale(1);
                    transform: scale(1);
          }
        }

        .v-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
          z-index: 5;
        }
        .v-overlay--absolute {
          position: absolute;
        }
        .v-overlay:before {
          bottom: 0;
          content: '';
          height: 100%;
          left: 0;
          opacity: 0;
          position: absolute;
          right: 0;
          top: 0;
          transition: inherit;
          transition-delay: 150ms;
          width: 100%;
        }
        .v-overlay--active {
          pointer-events: auto;
          touch-action: none;
        }
        .v-overlay--active:before {
          opacity: 0.46;
        }

        .theme--light.v-breadcrumbs .v-breadcrumbs__divider,
        .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {
          color: rgba(0,0,0,0.38);
        }
        .theme--dark.v-breadcrumbs .v-breadcrumbs__divider,
        .theme--dark.v-breadcrumbs .v-breadcrumbs__item--disabled {
          color: rgba(255,255,255,0.5);
        }
        .v-breadcrumbs {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          flex: 0 1 auto;
          list-style-type: none;
          margin: 0;
          padding: 18px 12px;
        }
        .v-breadcrumbs li {
          align-items: center;
          display: inline-flex;
        }
        .v-breadcrumbs li:nth-child(even) {
          padding: 0 12px;
        }
        .v-breadcrumbs__item {
          align-items: center;
          display: inline-flex;
          text-decoration: none;
          transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        .v-breadcrumbs__item--disabled {
          pointer-events: none;
        }

        
        .container {
          flex: 1 1 100%;
          margin: auto;
          padding: 24px;
          width: 100%;
        }
        .container.fluid {
          max-width: 100%;
        }
        .container.fill-height {
          align-items: center;
          display: flex;
        }
        .container.fill-height > .layout {
          height: 100%;
          flex: 1 1 auto;
        }
        .container.grid-list-xs .layout .flex {
          padding: 1px;
        }
        .container.grid-list-xs .layout:only-child {
          margin: -1px;
        }
        .container.grid-list-xs .layout:not(:only-child) {
          margin: auto -1px;
        }
        .container.grid-list-xs *:not(:only-child) .layout:first-child {
          margin-top: -1px;
        }
        .container.grid-list-xs *:not(:only-child) .layout:last-child {
          margin-bottom: -1px;
        }
        .container.grid-list-sm .layout .flex {
          padding: 2px;
        }
        .container.grid-list-sm .layout:only-child {
          margin: -2px;
        }
        .container.grid-list-sm .layout:not(:only-child) {
          margin: auto -2px;
        }
        .container.grid-list-sm *:not(:only-child) .layout:first-child {
          margin-top: -2px;
        }
        .container.grid-list-sm *:not(:only-child) .layout:last-child {
          margin-bottom: -2px;
        }
        .container.grid-list-md .layout .flex {
          padding: 4px;
        }
        .container.grid-list-md .layout:only-child {
          margin: -4px;
        }
        .container.grid-list-md .layout:not(:only-child) {
          margin: auto -4px;
        }
        .container.grid-list-md *:not(:only-child) .layout:first-child {
          margin-top: -4px;
        }
        .container.grid-list-md *:not(:only-child) .layout:last-child {
          margin-bottom: -4px;
        }
        .container.grid-list-lg .layout .flex {
          padding: 8px;
        }
        .container.grid-list-lg .layout:only-child {
          margin: -8px;
        }
        .container.grid-list-lg .layout:not(:only-child) {
          margin: auto -8px;
        }
        .container.grid-list-lg *:not(:only-child) .layout:first-child {
          margin-top: -8px;
        }
        .container.grid-list-lg *:not(:only-child) .layout:last-child {
          margin-bottom: -8px;
        }
        .container.grid-list-xl .layout .flex {
          padding: 12px;
        }
        .container.grid-list-xl .layout:only-child {
          margin: -12px;
        }
        .container.grid-list-xl .layout:not(:only-child) {
          margin: auto -12px;
        }
        .container.grid-list-xl *:not(:only-child) .layout:first-child {
          margin-top: -12px;
        }
        .container.grid-list-xl *:not(:only-child) .layout:last-child {
          margin-bottom: -12px;
        }
        .layout {
          display: flex;
          flex: 1 1 auto;
          flex-wrap: nowrap;
          min-width: 0;
        }
        .layout.row {
          flex-direction: row;
        }
        .layout.row.reverse {
          flex-direction: row-reverse;
        }
        .layout.column {
          flex-direction: column;
        }
        .layout.column.reverse {
          flex-direction: column-reverse;
        }
        .layout.column > .flex {
          max-width: 100%;
        }
        .layout.wrap {
          flex-wrap: wrap;
        }
        .flex,
        .child-flex > * {
          flex: 1 1 auto;
          max-width: 100%;
        }
        .align-start {
          align-items: flex-start;
        }
        .align-end {
          align-items: flex-end;
        }
        .align-center {
          align-items: center;
        }
        .align-baseline {
          align-items: baseline;
        }
        .align-self-start {
          align-self: flex-start;
        }
        .align-self-end {
          align-self: flex-end;
        }
        .align-self-center {
          align-self: center;
        }
        .align-self-baseline {
          align-self: baseline;
        }
        .align-content-start {
          align-content: flex-start;
        }
        .align-content-end {
          align-content: flex-end;
        }
        .align-content-center {
          align-content: center;
        }
        .align-content-space-between {
          align-content: space-between;
        }
        .align-content-space-around {
          align-content: space-around;
        }
        .justify-start {
          justify-content: flex-start;
        }
        .justify-end {
          justify-content: flex-end;
        }
        .justify-center {
          justify-content: center;
        }
        .justify-space-around {
          justify-content: space-around;
        }
        .justify-space-between {
          justify-content: space-between;
        }
        .justify-self-start {
          justify-self: flex-start;
        }
        .justify-self-end {
          justify-self: flex-end;
        }
        .justify-self-center {
          justify-self: center;
        }
        .justify-self-baseline {
          justify-self: baseline;
        }
        .spacer {
          flex-grow: 1 !important;
        }
        .grow {
          flex-grow: 1 !important;
          flex-shrink: 0 !important;
        }
        .shrink {
          flex-grow: 0 !important;
          flex-shrink: 1 !important;
        }
        .scroll-y {
          overflow-y: auto;
        }
        .fill-height {
          height: 100%;
        }
        .hide-overflow {
          overflow: hidden !important;
        }
        .show-overflow {
          overflow: visible !important;
        }
        .no-wrap {
          white-space: nowrap;
        }
        .ellipsis {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .d-flex {
          display: flex !important;
        }
        .d-inline-flex {
          display: inline-flex !important;
        }
        .d-flex > *,
        .d-inline-flex > * {
          flex: 1 1 auto !important;
        }
        .d-block {
          display: block !important;
        }
        .d-inline-block {
          display: inline-block !important;
        }
        .d-inline {
          display: inline !important;
        }
        @media only screen and (min-width: 960px) {
          .container {
            max-width: 900px;
          }
        }
        @media only screen and (min-width: 1264px) {
          .container {
            max-width: 1185px;
          }
        }
        @media only screen and (min-width: 1904px) {
          .container {
            max-width: 1785px;
          }
        }
        @media only screen and (max-width: 959px) {
          .container {
            padding: 16px;
          }
        }
        @media all and (min-width: 0) {
          .flex.xs1 {
            flex-basis: 8.333333333333332%;
            flex-grow: 0;
            max-width: 8.333333333333332%;
          }
          .flex.order-xs1 {
            order: 1;
          }
          .flex.xs2 {
            flex-basis: 16.666666666666664%;
            flex-grow: 0;
            max-width: 16.666666666666664%;
          }
          .flex.order-xs2 {
            order: 2;
          }
          .flex.xs3 {
            flex-basis: 25%;
            flex-grow: 0;
            max-width: 25%;
          }
          .flex.order-xs3 {
            order: 3;
          }
          .flex.xs4 {
            flex-basis: 33.33333333333333%;
            flex-grow: 0;
            max-width: 33.33333333333333%;
          }
          .flex.order-xs4 {
            order: 4;
          }
          .flex.xs5 {
            flex-basis: 41.66666666666667%;
            flex-grow: 0;
            max-width: 41.66666666666667%;
          }
          .flex.order-xs5 {
            order: 5;
          }
          .flex.xs6 {
            flex-basis: 50%;
            flex-grow: 0;
            max-width: 50%;
          }
          .flex.order-xs6 {
            order: 6;
          }
          .flex.xs7 {
            flex-basis: 58.333333333333336%;
            flex-grow: 0;
            max-width: 58.333333333333336%;
          }
          .flex.order-xs7 {
            order: 7;
          }
          .flex.xs8 {
            flex-basis: 66.66666666666666%;
            flex-grow: 0;
            max-width: 66.66666666666666%;
          }
          .flex.order-xs8 {
            order: 8;
          }
          .flex.xs9 {
            flex-basis: 75%;
            flex-grow: 0;
            max-width: 75%;
          }
          .flex.order-xs9 {
            order: 9;
          }
          .flex.xs10 {
            flex-basis: 83.33333333333334%;
            flex-grow: 0;
            max-width: 83.33333333333334%;
          }
          .flex.order-xs10 {
            order: 10;
          }
          .flex.xs11 {
            flex-basis: 91.66666666666666%;
            flex-grow: 0;
            max-width: 91.66666666666666%;
          }
          .flex.order-xs11 {
            order: 11;
          }
          .flex.xs12 {
            flex-basis: 100%;
            flex-grow: 0;
            max-width: 100%;
          }
          .flex.order-xs12 {
            order: 12;
          }
          .flex.offset-xs0 {
            margin-left: 0%;
          }
          .flex.offset-xs1 {
            margin-left: 8.333333333333332%;
          }
          .flex.offset-xs2 {
            margin-left: 16.666666666666664%;
          }
          .flex.offset-xs3 {
            margin-left: 25%;
          }
          .flex.offset-xs4 {
            margin-left: 33.33333333333333%;
          }
          .flex.offset-xs5 {
            margin-left: 41.66666666666667%;
          }
          .flex.offset-xs6 {
            margin-left: 50%;
          }
          .flex.offset-xs7 {
            margin-left: 58.333333333333336%;
          }
          .flex.offset-xs8 {
            margin-left: 66.66666666666666%;
          }
          .flex.offset-xs9 {
            margin-left: 75%;
          }
          .flex.offset-xs10 {
            margin-left: 83.33333333333334%;
          }
          .flex.offset-xs11 {
            margin-left: 91.66666666666666%;
          }
          .flex.offset-xs12 {
            margin-left: 100%;
          }
        }
        @media all and (min-width: 600px) {
          .flex.sm1 {
            flex-basis: 8.333333333333332%;
            flex-grow: 0;
            max-width: 8.333333333333332%;
          }
          .flex.order-sm1 {
            order: 1;
          }
          .flex.sm2 {
            flex-basis: 16.666666666666664%;
            flex-grow: 0;
            max-width: 16.666666666666664%;
          }
          .flex.order-sm2 {
            order: 2;
          }
          .flex.sm3 {
            flex-basis: 25%;
            flex-grow: 0;
            max-width: 25%;
          }
          .flex.order-sm3 {
            order: 3;
          }
          .flex.sm4 {
            flex-basis: 33.33333333333333%;
            flex-grow: 0;
            max-width: 33.33333333333333%;
          }
          .flex.order-sm4 {
            order: 4;
          }
          .flex.sm5 {
            flex-basis: 41.66666666666667%;
            flex-grow: 0;
            max-width: 41.66666666666667%;
          }
          .flex.order-sm5 {
            order: 5;
          }
          .flex.sm6 {
            flex-basis: 50%;
            flex-grow: 0;
            max-width: 50%;
          }
          .flex.order-sm6 {
            order: 6;
          }
          .flex.sm7 {
            flex-basis: 58.333333333333336%;
            flex-grow: 0;
            max-width: 58.333333333333336%;
          }
          .flex.order-sm7 {
            order: 7;
          }
          .flex.sm8 {
            flex-basis: 66.66666666666666%;
            flex-grow: 0;
            max-width: 66.66666666666666%;
          }
          .flex.order-sm8 {
            order: 8;
          }
          .flex.sm9 {
            flex-basis: 75%;
            flex-grow: 0;
            max-width: 75%;
          }
          .flex.order-sm9 {
            order: 9;
          }
          .flex.sm10 {
            flex-basis: 83.33333333333334%;
            flex-grow: 0;
            max-width: 83.33333333333334%;
          }
          .flex.order-sm10 {
            order: 10;
          }
          .flex.sm11 {
            flex-basis: 91.66666666666666%;
            flex-grow: 0;
            max-width: 91.66666666666666%;
          }
          .flex.order-sm11 {
            order: 11;
          }
          .flex.sm12 {
            flex-basis: 100%;
            flex-grow: 0;
            max-width: 100%;
          }
          .flex.order-sm12 {
            order: 12;
          }
          .flex.offset-sm0 {
            margin-left: 0%;
          }
          .flex.offset-sm1 {
            margin-left: 8.333333333333332%;
          }
          .flex.offset-sm2 {
            margin-left: 16.666666666666664%;
          }
          .flex.offset-sm3 {
            margin-left: 25%;
          }
          .flex.offset-sm4 {
            margin-left: 33.33333333333333%;
          }
          .flex.offset-sm5 {
            margin-left: 41.66666666666667%;
          }
          .flex.offset-sm6 {
            margin-left: 50%;
          }
          .flex.offset-sm7 {
            margin-left: 58.333333333333336%;
          }
          .flex.offset-sm8 {
            margin-left: 66.66666666666666%;
          }
          .flex.offset-sm9 {
            margin-left: 75%;
          }
          .flex.offset-sm10 {
            margin-left: 83.33333333333334%;
          }
          .flex.offset-sm11 {
            margin-left: 91.66666666666666%;
          }
          .flex.offset-sm12 {
            margin-left: 100%;
          }
        }
        @media all and (min-width: 960px) {
          .flex.md1 {
            flex-basis: 8.333333333333332%;
            flex-grow: 0;
            max-width: 8.333333333333332%;
          }
          .flex.order-md1 {
            order: 1;
          }
          .flex.md2 {
            flex-basis: 16.666666666666664%;
            flex-grow: 0;
            max-width: 16.666666666666664%;
          }
          .flex.order-md2 {
            order: 2;
          }
          .flex.md3 {
            flex-basis: 25%;
            flex-grow: 0;
            max-width: 25%;
          }
          .flex.order-md3 {
            order: 3;
          }
          .flex.md4 {
            flex-basis: 33.33333333333333%;
            flex-grow: 0;
            max-width: 33.33333333333333%;
          }
          .flex.order-md4 {
            order: 4;
          }
          .flex.md5 {
            flex-basis: 41.66666666666667%;
            flex-grow: 0;
            max-width: 41.66666666666667%;
          }
          .flex.order-md5 {
            order: 5;
          }
          .flex.md6 {
            flex-basis: 50%;
            flex-grow: 0;
            max-width: 50%;
          }
          .flex.order-md6 {
            order: 6;
          }
          .flex.md7 {
            flex-basis: 58.333333333333336%;
            flex-grow: 0;
            max-width: 58.333333333333336%;
          }
          .flex.order-md7 {
            order: 7;
          }
          .flex.md8 {
            flex-basis: 66.66666666666666%;
            flex-grow: 0;
            max-width: 66.66666666666666%;
          }
          .flex.order-md8 {
            order: 8;
          }
          .flex.md9 {
            flex-basis: 75%;
            flex-grow: 0;
            max-width: 75%;
          }
          .flex.order-md9 {
            order: 9;
          }
          .flex.md10 {
            flex-basis: 83.33333333333334%;
            flex-grow: 0;
            max-width: 83.33333333333334%;
          }
          .flex.order-md10 {
            order: 10;
          }
          .flex.md11 {
            flex-basis: 91.66666666666666%;
            flex-grow: 0;
            max-width: 91.66666666666666%;
          }
          .flex.order-md11 {
            order: 11;
          }
          .flex.md12 {
            flex-basis: 100%;
            flex-grow: 0;
            max-width: 100%;
          }
          .flex.order-md12 {
            order: 12;
          }
          .flex.offset-md0 {
            margin-left: 0%;
          }
          .flex.offset-md1 {
            margin-left: 8.333333333333332%;
          }
          .flex.offset-md2 {
            margin-left: 16.666666666666664%;
          }
          .flex.offset-md3 {
            margin-left: 25%;
          }
          .flex.offset-md4 {
            margin-left: 33.33333333333333%;
          }
          .flex.offset-md5 {
            margin-left: 41.66666666666667%;
          }
          .flex.offset-md6 {
            margin-left: 50%;
          }
          .flex.offset-md7 {
            margin-left: 58.333333333333336%;
          }
          .flex.offset-md8 {
            margin-left: 66.66666666666666%;
          }
          .flex.offset-md9 {
            margin-left: 75%;
          }
          .flex.offset-md10 {
            margin-left: 83.33333333333334%;
          }
          .flex.offset-md11 {
            margin-left: 91.66666666666666%;
          }
          .flex.offset-md12 {
            margin-left: 100%;
          }
        }
        @media all and (min-width: 1264px) {
          .flex.lg1 {
            flex-basis: 8.333333333333332%;
            flex-grow: 0;
            max-width: 8.333333333333332%;
          }
          .flex.order-lg1 {
            order: 1;
          }
          .flex.lg2 {
            flex-basis: 16.666666666666664%;
            flex-grow: 0;
            max-width: 16.666666666666664%;
          }
          .flex.order-lg2 {
            order: 2;
          }
          .flex.lg3 {
            flex-basis: 25%;
            flex-grow: 0;
            max-width: 25%;
          }
          .flex.order-lg3 {
            order: 3;
          }
          .flex.lg4 {
            flex-basis: 33.33333333333333%;
            flex-grow: 0;
            max-width: 33.33333333333333%;
          }
          .flex.order-lg4 {
            order: 4;
          }
          .flex.lg5 {
            flex-basis: 41.66666666666667%;
            flex-grow: 0;
            max-width: 41.66666666666667%;
          }
          .flex.order-lg5 {
            order: 5;
          }
          .flex.lg6 {
            flex-basis: 50%;
            flex-grow: 0;
            max-width: 50%;
          }
          .flex.order-lg6 {
            order: 6;
          }
          .flex.lg7 {
            flex-basis: 58.333333333333336%;
            flex-grow: 0;
            max-width: 58.333333333333336%;
          }
          .flex.order-lg7 {
            order: 7;
          }
          .flex.lg8 {
            flex-basis: 66.66666666666666%;
            flex-grow: 0;
            max-width: 66.66666666666666%;
          }
          .flex.order-lg8 {
            order: 8;
          }
          .flex.lg9 {
            flex-basis: 75%;
            flex-grow: 0;
            max-width: 75%;
          }
          .flex.order-lg9 {
            order: 9;
          }
          .flex.lg10 {
            flex-basis: 83.33333333333334%;
            flex-grow: 0;
            max-width: 83.33333333333334%;
          }
          .flex.order-lg10 {
            order: 10;
          }
          .flex.lg11 {
            flex-basis: 91.66666666666666%;
            flex-grow: 0;
            max-width: 91.66666666666666%;
          }
          .flex.order-lg11 {
            order: 11;
          }
          .flex.lg12 {
            flex-basis: 100%;
            flex-grow: 0;
            max-width: 100%;
          }
          .flex.order-lg12 {
            order: 12;
          }
          .flex.offset-lg0 {
            margin-left: 0%;
          }
          .flex.offset-lg1 {
            margin-left: 8.333333333333332%;
          }
          .flex.offset-lg2 {
            margin-left: 16.666666666666664%;
          }
          .flex.offset-lg3 {
            margin-left: 25%;
          }
          .flex.offset-lg4 {
            margin-left: 33.33333333333333%;
          }
          .flex.offset-lg5 {
            margin-left: 41.66666666666667%;
          }
          .flex.offset-lg6 {
            margin-left: 50%;
          }
          .flex.offset-lg7 {
            margin-left: 58.333333333333336%;
          }
          .flex.offset-lg8 {
            margin-left: 66.66666666666666%;
          }
          .flex.offset-lg9 {
            margin-left: 75%;
          }
          .flex.offset-lg10 {
            margin-left: 83.33333333333334%;
          }
          .flex.offset-lg11 {
            margin-left: 91.66666666666666%;
          }
          .flex.offset-lg12 {
            margin-left: 100%;
          }
        }
        @media all and (min-width: 1904px) {
          .flex.xl1 {
            flex-basis: 8.333333333333332%;
            flex-grow: 0;
            max-width: 8.333333333333332%;
          }
          .flex.order-xl1 {
            order: 1;
          }
          .flex.xl2 {
            flex-basis: 16.666666666666664%;
            flex-grow: 0;
            max-width: 16.666666666666664%;
          }
          .flex.order-xl2 {
            order: 2;
          }
          .flex.xl3 {
            flex-basis: 25%;
            flex-grow: 0;
            max-width: 25%;
          }
          .flex.order-xl3 {
            order: 3;
          }
          .flex.xl4 {
            flex-basis: 33.33333333333333%;
            flex-grow: 0;
            max-width: 33.33333333333333%;
          }
          .flex.order-xl4 {
            order: 4;
          }
          .flex.xl5 {
            flex-basis: 41.66666666666667%;
            flex-grow: 0;
            max-width: 41.66666666666667%;
          }
          .flex.order-xl5 {
            order: 5;
          }
          .flex.xl6 {
            flex-basis: 50%;
            flex-grow: 0;
            max-width: 50%;
          }
          .flex.order-xl6 {
            order: 6;
          }
          .flex.xl7 {
            flex-basis: 58.333333333333336%;
            flex-grow: 0;
            max-width: 58.333333333333336%;
          }
          .flex.order-xl7 {
            order: 7;
          }
          .flex.xl8 {
            flex-basis: 66.66666666666666%;
            flex-grow: 0;
            max-width: 66.66666666666666%;
          }
          .flex.order-xl8 {
            order: 8;
          }
          .flex.xl9 {
            flex-basis: 75%;
            flex-grow: 0;
            max-width: 75%;
          }
          .flex.order-xl9 {
            order: 9;
          }
          .flex.xl10 {
            flex-basis: 83.33333333333334%;
            flex-grow: 0;
            max-width: 83.33333333333334%;
          }
          .flex.order-xl10 {
            order: 10;
          }
          .flex.xl11 {
            flex-basis: 91.66666666666666%;
            flex-grow: 0;
            max-width: 91.66666666666666%;
          }
          .flex.order-xl11 {
            order: 11;
          }
          .flex.xl12 {
            flex-basis: 100%;
            flex-grow: 0;
            max-width: 100%;
          }
          .flex.order-xl12 {
            order: 12;
          }
          .flex.offset-xl0 {
            margin-left: 0%;
          }
          .flex.offset-xl1 {
            margin-left: 8.333333333333332%;
          }
          .flex.offset-xl2 {
            margin-left: 16.666666666666664%;
          }
          .flex.offset-xl3 {
            margin-left: 25%;
          }
          .flex.offset-xl4 {
            margin-left: 33.33333333333333%;
          }
          .flex.offset-xl5 {
            margin-left: 41.66666666666667%;
          }
          .flex.offset-xl6 {
            margin-left: 50%;
          }
          .flex.offset-xl7 {
            margin-left: 58.333333333333336%;
          }
          .flex.offset-xl8 {
            margin-left: 66.66666666666666%;
          }
          .flex.offset-xl9 {
            margin-left: 75%;
          }
          .flex.offset-xl10 {
            margin-left: 83.33333333333334%;
          }
          .flex.offset-xl11 {
            margin-left: 91.66666666666666%;
          }
          .flex.offset-xl12 {
            margin-left: 100%;
          }
        }
        .v-content {
          transition: none;
          display: flex;
          flex: 1 0 auto;
          max-width: 100%;
        }
        .v-content[data-booted="true"] {
          transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .v-content__wrap {
          flex: 1 1 auto;
          max-width: 100%;
          position: relative;
        }
        @-moz-document url-prefix() {
        }
        @media print {
          @-moz-document url-prefix() {
            .v-content {
              display: block;
            }
          }
        }
        #f-table {
          padding-bottom: 240px;
        }
        #f-table-s {
          padding-bottom: 10px;
        }
        #f-table-l {
          padding-bottom: 0px;
        }
        table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
        }
        th, td {
            padding: 2px;
            text-align: center;
        }
        th{
          background: #ffb366;
        }
        .t1{
          background: #ffb366;
        }
        .DD{
          display: block;
          float: center;
        }
        @media print {
          @page {
            margin: 0.1cm; 
          }
        }
        v-container{

        }        
        .fontLao{
        font-family: phetsarath ot !important;
        }
      `;
      self.d.print(document.getElementById("printdoc"), cssText);
    }
  }
};
</script>

<style>
.fontLao {
  font-family: phetsarath ot !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportAll.vue